module.exports = __webpack_public_path__ + "static/media/star_empty.49456643.svg";